
		<base-support-modal
			[title]="title"
			[btnOkClass]="'btn-warning'"
			[btnOkLabel]="'Установить'"
			(onOk)="ok()"
			[form]="form"
		>
			<div
				class="alert alert-danger"
				role="alert"
				*ngIf="site.promopult"
			>
				Зачисление денег произойдёт в сервис продвижения сайтов Promopult!<br/>
				Сумма указывается в рублях!
			</div>
			
			<div
				class="row"
				*ngIf="site.promopult; else noPromopultUser"
			>
				<div class="col-12">
					Баланс {{ site.promopult.balance }} {{ helper.currencyLabels['rub'] }}
				</div>

				<div class="col-12">
					Статус
					<span class="badge badge-{{ site.promopult.status === 'run' ? 'success' : 'warning' }}">
						{{ site.promopult.status }}
					</span>
				</div>
			</div>
			
			
			<ng-template #noPromopultUser>
				<div class="alert alert-danger" role="alert">
					У сайта нет промопульт-аккаунта
				</div>
			</ng-template>
			
			<hr/>
			
			<div [formGroup]="form">
				<div class="form-group">
					<h5>
						Тип операции
					</h5>
					
					<div class="form-check">
						<label class="form-check-label">
							<input
								class="form-check-input" type="radio"
								formControlName="type"
								value="increase"
							>

							пополнить
						</label>
					</div>
					<div class="form-check">
						<label class="form-check-label">
							<input
								class="form-check-input" type="radio"
								formControlName="type"
								value="decrease"
							>

							уменьшить
						</label>
					</div>
				</div>
				
				<div class="form-row">
					<div class="col-2">
						<h5>
							Сумма
						</h5>
					</div>
					
					<div class="col-8">
						<input
							type="number"
							class="form-control"
							formControlName="amount"
							[formErrorIndicator]="form.get('amount')"
						/>
					</div>
					
					<div class="col-2">
						руб.
					</div>
				</div>
			</div>
		</base-support-modal>

	